import React from "react";
import { EditorPopup } from "../../../popup/components/EditorPopup/EditorPopup";
import { getImageMenuState, hideImageMenu, setImageMenuState, showImageMenu, } from "../../plugins/image-menu.plugin";
import { EditorImageMenu } from "../EditorImageMenu/EditorImageMenu";
export const EditorImageMenuPluginView = ({ view, onFullscreen }) => {
    const pluginState = getImageMenuState(view.state);
    if (!pluginState) {
        return null;
    }
    const { pos, target } = pluginState;
    const node = view.state.doc.nodeAt(pos);
    if (!node || node.type !== view.state.schema.nodes.image) {
        return null;
    }
    const attrs = node.attrs;
    const setNodeAttrs = (updatedAttrs) => {
        view.dispatch(view.state.tr.setNodeMarkup(pos, null, {
            ...attrs,
            ...updatedAttrs,
        }));
        view.focus();
    };
    const removeNode = () => {
        view.dispatch(view.state.tr.delete(pos, pos + 1));
        view.dispatch(setImageMenuState(view.state.tr, null));
        view.focus();
    };
    const focusCaption = () => {
        var _a;
        (_a = target.querySelector("textarea")) === null || _a === void 0 ? void 0 : _a.focus();
    };
    return (React.createElement(EditorPopup, { view: view, referenceElement: target, placement: "top", visibleWhenEditorUnfocused: true },
        React.createElement(EditorImageMenu, { editable: view.editable, attrs: attrs, onAlign: (alignment) => setNodeAttrs({ alignment }), onCaption: focusCaption, onRemove: removeNode, onFullscreen: () => onFullscreen(attrs), onMouseEnter: () => showImageMenu(view), onMouseLeave: () => hideImageMenu(view) })));
};
